/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import bnbLogo from './bnb.png';
import fsmaLogo from './fsma.png';
import safeInternetBankingLogo from './safeinternetbanking.png';

const protectionIllustrationStyle: ouiStyle.InStyleWithMediaQueries = {
  widthLines: [8, undefined, undefined, 'auto', undefined, undefined],
  margin: 'auto',
  paddingVertical: ['double', undefined, undefined, 'none', undefined, undefined],
};

const protectionIllustrationCss = ouiStyle.mediaQuery(ouiStyle.makeCss(protectionIllustrationStyle));

const protectionIllustrationSmallStyle: ouiStyle.InStyleWithMediaQueries = {
  widthLines: [2, undefined, undefined, 'auto', undefined, undefined],
  margin: 'auto',
  paddingVertical: ['double', undefined, undefined, 'none', undefined, undefined],
};

const protectionIllustrationSmallCss = ouiStyle.mediaQuery(ouiStyle.makeCss(protectionIllustrationSmallStyle));

export const OtherProtectionsIllustrationSectionContent = () => (
  <React.Fragment>
    <img
      css={protectionIllustrationCss}
      src={safeInternetBankingLogo}
      alt="logo safe internet banking"
    />
    <img
      css={protectionIllustrationCss}
      src={bnbLogo}
      alt="logo de la banque nationale de Belgique"
    />
    <img
      css={protectionIllustrationSmallCss}
      src={fsmaLogo}
      alt="logo de l'Autorité des Services et Marchés Financiers"
    />
  </React.Fragment>
);
